exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cell__Transport_1_plan_extern-module___2nnHK .regplate__Transport_1_plan_extern-module___1b7iD {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex-shrink: 0;\n    font-size: 12px;\n}\n\n@media (max-width: 762px) {\n    \n    .cell__Transport_1_plan_extern-module___2nnHK {\n        padding-bottom: 12px;\n    }\n\n    .statusLabel__Transport_1_plan_extern-module___18akv {\n        /* white-space: normal; */\n        font-size: 10px;\n    }\n    \n    }", ""]);

// Exports
exports.locals = {
	"cell": "cell__Transport_1_plan_extern-module___2nnHK",
	"regplate": "regplate__Transport_1_plan_extern-module___1b7iD",
	"statusLabel": "statusLabel__Transport_1_plan_extern-module___18akv"
};